import { render } from "./NewsItem.vue?vue&type=template&id=0fc1239c&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=0fc1239c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc1239c"]])

export default __exports__